import { NavLink } from 'react-router-dom'
import { Images, FolderOpen, Users, Settings, Shield, FileStack } from 'lucide-react'
import { useGetAdminStatusQuery } from '@/store/api'

const navItems = [
  { to: '/library', icon: Images, label: 'Library' },
  { to: '/files', icon: FileStack, label: 'Files' },
  { to: '/albums', icon: FolderOpen, label: 'Albums' },
  { to: '/faces', icon: Users, label: 'Faces' },
]

const bottomItems = [
  { to: '/admin', icon: Shield, label: 'Admin' },
  { to: '/settings', icon: Settings, label: 'Settings' },
]

function Sidebar() {
  return (
    <aside className="h-full w-sidebar bg-card border-r border-border flex flex-col">
      {/* Logo */}
      <div className="p-4 border-b border-border">
        <h1 className="text-xl font-bold text-primary">PIXSIFT</h1>
      </div>

      {/* Main Navigation */}
      <nav className="flex-1 p-2">
        <ul className="space-y-1">
          {navItems.map(({ to, icon: Icon, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-md transition-colors ${
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                  }`
                }
              >
                <Icon size={20} />
                <span>{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="my-4 border-t border-border" />

        <ul className="space-y-1">
          {bottomItems.map(({ to, icon: Icon, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-md transition-colors ${
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                  }`
                }
              >
                <Icon size={20} />
                <span>{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Service Status Summary */}
      <div className="p-4 border-t border-border">
        <ServiceStatusSummary />
      </div>
    </aside>
  )
}

function ServiceStatusSummary() {
  const { data: status } = useGetAdminStatusQuery(undefined, { pollingInterval: 30000 })
  const total = status?.services.length ?? 0
  const running = status?.services.filter(s => s.status === 'running').length ?? 0

  return (
    <div className="text-sm text-muted-foreground">
      <div className="flex items-center gap-2">
        <span className={`status-dot ${
          running === 0 ? 'status-stopped' : running === total ? 'status-running' : 'status-starting'
        }`} />
        <span>{running}/{total} Services</span>
      </div>
    </div>
  )
}

export default Sidebar
